'use strict';

import React, { Component } from "react";
import ReactDOM from "react-dom";
import PicsApi from '../includes/PicsApi';
// ctspritepath is located in CTBase.cshtml file

class AlertsHeader extends Component {
    constructor(props) {
        super(props);
        this.state = props;
        
        window.addEventListener('storage', (e) => {
            this.setState(getState());
        });
    }

    _setState = (state) => {
        setState(state);
    };

    render() {
        let title = 'Rider Alerts';

        if (this.state.alert) {
            if (this.state.alertLiveId) {
                title = 'Alert ' + this.state.alertLiveId + ' - ' + (this.state.alert.cause_name ? this.state.alert.cause_name : this.state.alert.effect_name);
            } else if (this.state.alertPlannedId) {
                title = this.state.alert.Title;
            }
        }

        return (
            <div id="alerts-header">
                <div id="alerts-header-container">
                    <div id="alerts-header-left">
                        <svg role="img" aria-label="Alert"><use xlinkHref={ctspritepath + '#rider-alerts'}></use></svg>
                        <h3>{title}</h3>
                    </div>
                    <div id="alerts-header-right">
                    </div>
                </div>
            </div>
        );
    }
}

class AlertsDetail extends Component {
    constructor(props) {
        super(props);
        this.state = props;

        window.addEventListener('storage', (e) => {
            this.setState(getState());
        });
    }

    _setState = (state) => {
        setState(state);
    };

    componentDidMount = () => {
        if (this.state.alertLiveId) {
            PicsApi.getAlert(this.state.alertLiveId)
                .then(response => response.json())
                .then(results => {
                    if (results && results.alert_id) {
                        let routes = [];
                        let stops = [];

                        if (results.affected_services && results.affected_services.services && results.affected_services.services.length) {
                            results.affected_services.services.forEach(service => {
                                if (service) {
                                    if (service.route_id && !routes.find(route => route.route_id == service.route_id)) {
                                        routes.push(service);
                                    }

                                    if (service.stop_id && !stops.find(stop => stop.stop_id == service.stop_id)) {
                                        stops.push(service);
                                    }
                                }
                            });

                            routes.sort((a, b) => a.route_id - b.route_id);
                            stops.sort((a, b) => a.stop_id - b.stop_id);
                        }

                        this._setState({
                            alert: results,
                            routes,
                            stops
                        });
                    } else {
                        this._setState({
                            alert: null,
                            routes: [],
                            stops: []
                        });
                    }
                })
                .catch(error => {
                    this._setState({
                        alert: null,
                        routes: [],
                        stops: []
                    });
                });
        } else if (this.state.alertPlannedId) {
            fetch('/restapi/rideralerts/' + this.state.alertPlannedId + '?format=json')
                .then(response => response.json())
                .then(result => {
                    if (result && result.Results && result.Results.length) {
                        let routes = [];

                        if (result.Results[0].Routes && result.Results[0].Routes.length) {
                            routes = result.Results[0].Routes.map(route => {
                                return {
                                    route_id: route
                                };
                            });

                            routes.sort((a, b) => a.route_id - b.route_id);
                        }

                        this._setState({
                            alert: result.Results[0],
                            routes,
                            stops: []
                        });
                    } else {
                        this._setState({
                            alert: null,
                            routes: [],
                            stops: []
                        });
                    }
                })
                .catch(error => {
                    this._setState({
                        alert: null,
                        routes: [],
                        stops: []
                    });
                });
        }
    };

    formatDate = (timestamp) => {
        if (!timestamp || isNaN(parseInt(timestamp))) {
            return 'further notice';
        }

        const date = new Date(parseInt(timestamp) * 1000);

        return date.toLocaleDateString('en-US', { timeZone: 'America/Los_Angeles', weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' }) + ' at ' + date.toLocaleTimeString('en-US', { timeZone: 'America/Los_Angeles', timeStyle: 'short', hour12: true });
    };

    formatDateString = (date) => {
        return this.formatDate((new Date(date)).getTime() / 1000);
    };

    redirect = (e, type, data) => {
        e.preventDefault();

        if (data) {
            if (type == 'route' && data.route_id) {
                location.href = '/route/' + encodeURIComponent(data.route_id);
            } else if (type == 'stop' && data.stop_id) {
                location.href = '/stop/' + encodeURIComponent(data.stop_id);
            }
        }
    };

    render() {
        if (!this.state.alert) {
            return null;
        }

        let alert = { ...this.state.alert };
        let end = '';
        let cause = '';

        if (this.state.alertLiveId) {
            end = this.formatDate(alert.effect_periods && alert.effect_periods.length && alert.effect_periods[0].effect_end ? alert.effect_periods[0].effect_end : '');
            cause = (alert.cause_name ? alert.cause_name : alert.effect_name);

            if (cause) {
                cause = cause.toLowerCase();
            }
        }

        return (
            <div id="alerts-detail">
                {this.state.alertLiveId ? (
                    <>
                        <div id="alerts-detail-date">{this.formatDate(alert.effect_periods && alert.effect_periods.length && alert.effect_periods[0].effect_start ? alert.effect_periods[0].effect_start : alert.created_dt)}</div>
                        <div id="alerts-detail-description">
                            <p>{alert.header_text}</p>
                            {alert.description_text ? (
                                <p>{alert.description_text}</p>
                            ) : null}
                            {alert.url ? (
                                <p>Learn more at <a href={alert.url}>{alert.url}</a></p>
                            ) : null}
                        </div>
                        {this.state.stops && this.state.stops.length ? (
                            <ul id="alerts-detail-stops" class="un-list">
                                <p>The following stop{this.state.stops.length == 1 ? ' is' : 's are'} affected until {end}:</p>
                                {this.state.stops.map(stop =>
                                    <li class="alert-detail-stop">
                                        <svg role="img" aria-label="Stop"><use xlinkHref={ctspritepath + '#tracker-bus'}></use></svg><a href="#" onClick={e => { this.redirect(e, 'stop', stop); }}>{stop.stop_id} - {stop.stop_name}</a>
                                    </li>
                                )}
                            </ul>
                        ) : null}
                        {this.state.routes && this.state.routes.length ? (
                            <ul id="alerts-detail-routes" class="un-list">
                                <p>The following route{this.state.routes.length == 1 ? ' is' : 's are'} affected until {end}:</p>
                                {this.state.routes.map(route => {
                                    const _route = _routes.find(r => r.route_id == route.route_id);

                                    return (
                                        <li class="alert-detail-route">
                                            <svg role="img" aria-label="Route"><use xlinkHref={ctspritepath + '#bus'}></use></svg><a href="#" onClick={e => { this.redirect(e, 'route', route); }}>{_route ? _route.route_short_name : route.route_id} - {_route ? _route.route_name : route.route_name}</a>
                                        </li>
                                    );
                                })}
                            </ul>
                        ) : null}
                    </>
                ) : (
                    <>
                        <div id="alerts-detail-date">{this.formatDateString(alert.PublicationDate)}</div>
                        {alert.Description ? (
                            <div id="alerts-detail-description" dangerouslySetInnerHTML={{ __html: alert.Description }} />
                        ) : null}
                        {this.state.routes && this.state.routes.length ? (
                                <>
                                    <p><br/>The following route{this.state.routes.length == 1 ? ' is' : 's are'} affected:</p>
                                    <ul id="alerts-detail-routes" class="un-list">
                                        {this.state.routes.map(route => {
                                            const _route = _routes.find(r => r.route_id == route.route_id);

                                            return (
                                                <li class="alert-detail-route">
                                                    <svg role="img" aria-label="Route"><use xlinkHref={ctspritepath + '#bus'}></use></svg><a href="#" onClick={e => { this.redirect(e, 'route', route); }}>{_route ? _route.route_short_name : route.route_id} - {_route ? _route.route_name : 'N/A'}</a>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </>
                        ) : null}
                    </>
                )}
            </div>
        );
    }
}

let alertLiveId = null;
let alertPlannedId = null;

if (location.pathname.startsWith('/alert/')) {
    const parts = location.pathname.split('/');

    if (parts.length == 3) {
        if (parts[2].length == 36) {
            alertPlannedId = decodeURIComponent(parts[2]);
        } else {
            alertLiveId = decodeURIComponent(parts[2]);
        }
    }
}

function getState() {
    if (sessionStorage.getItem('Alert')) {
        return JSON.parse(sessionStorage.getItem('Alert'));
    }

    return null;
}

function setState(partialState) {
    let state = getState();

    if (!state) {
        state = {};
    }

    sessionStorage.setItem('Alert', JSON.stringify({
        ...state,
        ...partialState
    }));
    
    window.dispatchEvent(new Event('storage'));
}

let cachedState = getState();

if (cachedState) {
    cachedState.alert = null;
    cachedState.alertLiveId = alertLiveId;
    cachedState.alertPlannedId = alertPlannedId;
    cachedState.routes = [];
    cachedState.stops = [];

    setState(cachedState);
} else {
    setState({
        alert: null,
        alertLiveId,
        alertPlannedId,
        routes: [],
        stops: []
    });
}

if (document.getElementById('alerts-header-root')) {
    ReactDOM.render(
        <AlertsHeader {...getState()} />,
        document.getElementById('alerts-header-root')
    );
}

if (document.getElementById('alerts-detail-root')) {
    ReactDOM.render(
        <AlertsDetail {...getState()} />,
        document.getElementById('alerts-detail-root')
    );
}